module.exports = __webpack_public_path__ + "img/check.2ac3f8d.png";